import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import Layout from '../../components/Layout';
import { CustomFieldsTab } from './components/CustomFieldsTab';
import { DailyHabitsTab } from './components/DailyHabitsTab';
import { DashboardTab } from './components/DashboardTab';
import { AccountTab } from './components/AccountTab';
import { UsersTab } from './components/UsersTab';
import { useAuth } from '../../context/AuthContext';

const Settings: React.FC = () => {
  const { isAdmin } = useAuth();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Layout>
      <Box sx={{ width: '100%', maxWidth: 1000, mx: 'auto', p: 2 }}>
        <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold', mb: 3 }}>
          Settings
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={activeTab} onChange={handleTabChange} aria-label="settings tabs" variant="scrollable" scrollButtons="auto">
            <Tab label="Custom Data Fields" id="settings-tab-0" />
            <Tab label="Daily Habits" id="settings-tab-1" />
            <Tab label="Dashboard" id="settings-tab-2" />
            <Tab label="Account" id="settings-tab-3" />
            {isAdmin && <Tab label="Users" id="settings-tab-4" />}
          </Tabs>
        </Box>

        {activeTab === 0 && <CustomFieldsTab />}
        {activeTab === 1 && <DailyHabitsTab />}
        {activeTab === 2 && <DashboardTab />}
        {activeTab === 3 && <AccountTab />}
        {isAdmin && activeTab === 4 && <UsersTab />}
      </Box>
    </Layout>
  );
};

export default Settings;
